<template>
    <div id="app" class="admin-login-container">
        <transition name="el-fade15">
            <div v-show="pageVisible" class="admin-login-body">
                <div class="admin-login-form">
                    <div class="login-logo">
                        <svg>
                            <use xlink:href="#logo"></use>
                        </svg>
                    </div>
                    <h3 class="login-title">用户登录</h3>
                    <el-form :model="loginForm" :rules="loginRules" ref="loginForm">
                        <el-form-item class="item-username" prop="username">
                            <el-input v-model="loginForm.username" placeholder="Username" autocomplete="off" suffix-icon="fas fa-user"></el-input>
                        </el-form-item>
                        <el-form-item class="item-password" prop="password">
                            <el-input type="password" v-model="loginForm.password" placeholder="Password" autocomplete="off" suffix-icon="fas fa-lock" @keyup.enter.native="submitForm()"></el-input>
                            <el-button v-if="enableForgetPwd" class="forget-pwd" type="text">忘记密码?</el-button>
                        </el-form-item>
                        <el-form-item class="item-actions1">
                            <el-col v-if="enableRememberMe" :span="16">
                                <el-checkbox class="remember-me" v-model="loginForm.rememberMe">Remember me</el-checkbox>
                            </el-col>
                            <el-col :span="enableRememberMe ? 8 : 24">
                                <el-button :class="['login-button', {'large': !enableRememberMe}]" type="primary" :loading="submiting" @click="submitForm()">立即登录</el-button>
                            </el-col>
                        </el-form-item>
                        <el-form-item class="item-actions2" v-if="enableRegister">
                            <span>你还没有注册账户?&nbsp;&nbsp;<el-button type="text" @click="goToRegister">立即注册</el-button></span>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import '@/assets/svg/logo.svg';

import {
    API_ACCESS_TOKEN_EXPIRATION_TIME,
    defaultApiErrorHandler,
    PLATFORM_API,
    LOGIN_API_URL
} from '@/api.js';
import { ADMIN_INDEX_URL, ADMIN_REGISTER_URL } from '@/constants.js';
import qs from 'qs';

export default {
    name: 'app',
    data() {
        return {
            pageVisible: false,
            enableRememberMe: false,
            enableRegister: true,
            enableForgetPwd: false,
            submiting: false,
            loginForm: {
                username: '',
                password: '',
                rememberMe: false
            },
            loginRules: {
                username: [
                    {
                        required: true,
                        message: '请输入用户名',
                        trigger: 'change'
                    }
                ],
                password: [
                    {
                        required: true,
                        message: '请输入密码',
                        trigger: 'change'
                    }
                ]
            }
        };
    },
    mounted() {
        this.pageVisible = true;
    },
    methods: {
        submitForm() {
            this.$refs.loginForm.validate(valid => {
                if (valid && !this.submiting) {
                    this.submiting = true;
                    let userAccessState = this.getUserAccessState();
                    let lastAccessWebUrl = userAccessState.lastAccessWebUrl;
                    let lastAccessTime = userAccessState.secondLastAccessTime
                        ? userAccessState.secondLastAccessTime
                        : 0;
                    this.resetStore(); //reset vuex store before login
                    this.$http
                        .post(
                            PLATFORM_API.of(LOGIN_API_URL),
                            qs.stringify(this.loginForm),
                            {
                                headers: {
                                    //spring-security的默认登录[POST]处理的ContentType就是application/x-www-form-urlencoded
                                    'Content-Type':
                                        'application/x-www-form-urlencoded'
                                }
                            }
                        )
                        .then(response => {
                            let result = response.data;
                            if (result.success) {
                                //this.$message.success(result.message);
                                this.setAccessToken(result.data);
                                let expireTimes =
                                    (new Date().getTime() - lastAccessTime) /
                                    1000;
                                if (
                                    userAccessState.userName ==
                                        this.loginForm.username &&
                                    lastAccessWebUrl &&
                                    expireTimes <
                                        API_ACCESS_TOKEN_EXPIRATION_TIME
                                ) {
                                    //同一用户因为登录凭证失效而导致的重新登录?
                                    window.location.href = lastAccessWebUrl;
                                } else {
                                    window.location.href = ADMIN_INDEX_URL;
                                }
                            } else {
                                this.$message.error(result.message);
                            }
                        })
                        .catch(defaultApiErrorHandler)
                        .then(() => {
                            this.submiting = false;
                        });
                } else {
                    return false;
                }
            });
        },
        resetForm() {
            console.log('reset');
        },
        setAccessToken(token) {
            token.acquired_time = new Date().getTime();
            this.$store.dispatch('executeUpdateAccessToken', token);
        },
        getUserAccessState() {
            return this.$store.getters.getUserAccessState();
        },
        resetStore() {
            this.$store.dispatch('resetStore4Logout');
        },
        goToRegister() {
            window.location.href = ADMIN_REGISTER_URL;
        }
    }
};
</script>

<style lang="scss">
</style>